'use client'

import ParkinglotDetailMap from '@/components/myTicket/components/parkinglotDetailMap/view'
import PurchaseClientView from '@/components/purchase/view'
import RoadView from '@/components/roadview/view'
import ParkingTicketDetailView from '@/components/ticketDetail/components/parkinglot/view'
import useTicketDetailViewModel from '@/components/ticketDetail/viewModel'

import type { Ticket } from '@/api/dto/ticket'
import type { ParkinglotDetail, SharedParkinglotDetail, TicketsItem } from '@/api/server/detail/dto/detailDto'
import Cover from '@/shared/components/Cover'
interface TicketDetailViewProps {
  ticket: Ticket
  tickets: TicketsItem[]
  pin: ParkinglotDetail | SharedParkinglotDetail
  geoCodeNeighborsWithSelf: string
}

const TicketDetailView = ({ ticket, tickets, pin, geoCodeNeighborsWithSelf }: TicketDetailViewProps) => {
  const { states, setters } = useTicketDetailViewModel({ ticket })

  const roadViewProps = {
    isRoadViewOpen: states.isRoadViewOpen,
    setIsRoadViewOpen: setters.setIsRoadViewOpen,
    latitude: ticket.parkinglot.parkinglotLatitude,
    longitude: ticket.parkinglot.parkinglotLongitude
  }

  const parkinglotDetailMapProps = {
    isDetailMapOpen: states.isDetailMapOpen,
    setIsDetailMapOpen: setters.setIsDetailMapOpen,
    parkinglotAddress: ticket.parkinglot.parkinglotAddress,
    parkinglotName: ticket.parkinglot.parkinglotName,
    latitude: ticket.parkinglot.parkinglotLatitude,
    longitude: ticket.parkinglot.parkinglotLongitude,
    onClickNaviBtn: () => {}
  }

  const purchaseProps = {
    data: states.ticket
  }

  if (roadViewProps.isRoadViewOpen) {
    return <RoadView {...roadViewProps} />
  }

  if (parkinglotDetailMapProps.isDetailMapOpen) {
    return <ParkinglotDetailMap {...parkinglotDetailMapProps} />
  }

  return (
    <Cover
      isOpen
      id="layer2"
      style
      zIndex={'z-200'}
      className={`relative w-full pb-20 ${states.isPurchase ? '' : 'pt-[60px]'}`}
    >
      {!states.isPurchase && (
        <ParkingTicketDetailView
          ticket={states.ticket}
          setTicket={setters.setTicket}
          tickets={tickets}
          pin={pin}
          setIsRoadViewOpen={setters.setIsRoadViewOpen}
          setIsDetailMapOpen={setters.setIsDetailMapOpen}
          geoCodeNeighborsWithSelf={geoCodeNeighborsWithSelf}
        />
      )}
      {states.isPurchase && <PurchaseClientView {...purchaseProps} />}
    </Cover>
  )
}

export default TicketDetailView
